import React from 'react'
import { useFocusable } from '@noriginmedia/norigin-spatial-navigation'
import { useNavigate } from 'react-router-dom'
import tts from '../../lib/TTS.js'
import urls from '../../lib/urls'
import FocusableButtonTS from '../../components/FocusableButton/FocusableButtonTS'
import { ConfirmDonationProps } from './types'

const COMPONENT_FOCUS_KEY = 'CONFIRM_DONATION'
const OKAY_BUTTON_FOCUS_KEY = `${COMPONENT_FOCUS_KEY}_OKAY_BUTTON`
const TITLE = 'Your upcoming donations have been cancelled.'
const PARAGRAPH_1 = 'You will not be billed for future recurring donations.'
const PARAGRAPH_2 = "You'll continue to have access to"
const PARAGRAPH_4 =
  'Passport benefits, including extended access to your favorite PBS shows and films through the end of your billing cycle.'
const PARAGRAPH_3 =
  'If you change your mind, visit PBS.org or contact your local station to make another donation.'
const OKAY_TEXT = 'Okay'

const ConfirmDonation = ({ donationInfo }: ConfirmDonationProps) => {
  const navigate = useNavigate()
  const { ref } = useFocusable()

  const handleButtonFocus = () => {
    const buttonTts = `Focused on ${OKAY_TEXT} Button.`

    tts.stopRead()
    tts.addTextToRead(
      `${TITLE} .... ${PARAGRAPH_1} .... ${PARAGRAPH_2} ${' '}${
        donationInfo.shortNameStation
      }${' '}${PARAGRAPH_4}.... ${PARAGRAPH_3} .... ${buttonTts}`
    )
  }

  const handleButtonEnter = () => {
    navigate(-3)
  }

  return (
    <>
      <div ref={ref} className="cancellation-donation-screen__cancel">
        <div className="cancellation-donation-screen__cancel__container-title">
          <h1 className="cancellation-donation-screen__cancel__title">
            {TITLE}
          </h1>
        </div>
        <div className="cancellation-donation-screen__cancel__description">
          <p className="cancellation-donation-screen__cancel__message">
            {PARAGRAPH_1}
          </p>
          <p className="cancellation-donation-screen__cancel__message">
            {PARAGRAPH_2} {donationInfo.shortNameStation} {PARAGRAPH_4}
          </p>
          <p className="cancellation-donation-screen__cancel__message">
            If you change your mind, visit
            <a
              className="cancellation-donation-screen__manage__member-info__link"
              href={urls.DONATE_URL}
            >
              {' '}
              {urls.PBS_URL}{' '}
            </a>
            or contact your local station to make another donation.
          </p>
          <div className="cancellation-donation-screen__cancel__container-buttons">
            <FocusableButtonTS
              focusKey={OKAY_BUTTON_FOCUS_KEY}
              onEnterPress={handleButtonEnter}
              onFocus={handleButtonFocus}
              stealFocus={true}
            >
              {OKAY_TEXT}
            </FocusableButtonTS>
          </div>
        </div>
      </div>
    </>
  )
}

export default ConfirmDonation
